@if (!allSet) {
  <div class="loading">
    <img
      src="./assets/images/init-loading.gif"
      alt="loading sell process"
      class="loading-image"
      />
    </div>
  }
  @if (allSet) {
    <router-outlet></router-outlet>
  }
